import { useEffect, useState } from "react";

const API = "https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod";

export default function App() {
  const [destinations, setDestinations] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [tours, setTours] = useState([]);

  // ================= LOADERS =================
  const loadDestinations = async () => {
    const r = await fetch(`${API}/tours/destination`);
    const j = await r.json();
    setDestinations(Array.isArray(j) ? j : []);
  };

  const loadVehicles = async () => {
    const r = await fetch(`${API}/tours/vehicles`);
    const j = await r.json();
    setVehicles(Array.isArray(j) ? j : []);
  };

  const loadTours = async () => {
    const r = await fetch(`${API}/tours`);
    const j = await r.json();
    setTours(Array.isArray(j) ? j : []);
  };

  useEffect(() => {
    loadDestinations();
    loadVehicles();
    loadTours();
  }, []);

  // ================= CREATE =================
  const createDestination = async (e) => {
    e.preventDefault();
    await fetch(`${API}/tours/destination`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: e.target.name.value })
    });
    e.target.reset();
    loadDestinations();
  };

  const createVehicle = async (e) => {
    e.preventDefault();
    await fetch(`${API}/tours/vehicles`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: e.target.name.value,
        capacity: Number(e.target.capacity.value),
        max_capacity: Number(e.target.max_capacity.value),
        plate: e.target.plate.value
      })
    });
    e.target.reset();
    loadVehicles();
  };

  const createTour = async (e) => {
    e.preventDefault();
    await fetch(`${API}/tours`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: e.target.name.value,
        destination: e.target.destination.value,
        vehicle_id: Number(e.target.vehicle_id.value),
        departure_date: e.target.departure_date.value,
        departure_time: e.target.departure_time.value,
        price: Number(e.target.price.value),
        max_capacity: Number(e.target.max_capacity.value)
      })
    });
    e.target.reset();
    loadTours();
  };

  return (
    <div style={{ padding: 30, fontFamily: "Arial" }}>
      <h1>🚌 Tours Admin</h1>

      {/* DESTINATIONS */}
      <h2>Destinos</h2>
      <form onSubmit={createDestination}>
        <input name="name" placeholder="Destino" required />
        <button>Crear</button>
      </form>
      <ul>
        {destinations.map(d => (
          <li key={d.id}>{d.name}</li>
        ))}
      </ul>

      <hr />

      {/* VEHICLES */}
      <h2>Vehículos</h2>
      <form onSubmit={createVehicle}>
        <input name="name" placeholder="Nombre" required />
        <input name="capacity" type="number" placeholder="Capacidad" required />
        <input name="max_capacity" type="number" placeholder="Máx" required />
        <input name="plate" placeholder="Placas" />
        <button>Crear</button>
      </form>
      <ul>
        {vehicles.map(v => (
          <li key={v.id}>
            {v.name} – {v.max_capacity}
          </li>
        ))}
      </ul>

      <hr />

      {/* TOURS */}
      <h2>Tours</h2>
      <form onSubmit={createTour}>
        <input name="name" placeholder="Nombre" required />

        <select name="destination">
          {destinations.map(d => (
            <option key={d.id} value={d.name}>{d.name}</option>
          ))}
        </select>

        <select name="vehicle_id">
          {vehicles.map(v => (
            <option key={v.id} value={v.id}>{v.name}</option>
          ))}
        </select>

        <input type="date" name="departure_date" required />
        <input type="time" name="departure_time" required />
        <input type="number" name="price" placeholder="Precio" required />
        <input type="number" name="max_capacity" placeholder="Capacidad" required />

        <button>Crear Tour</button>
      </form>

      <table border="1" cellPadding="6" style={{ marginTop: 20 }}>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Destino</th>
            <th>Fecha</th>
            <th>Hora</th>
            <th>Precio</th>
            <th>Vehículo</th>
          </tr>
        </thead>
        <tbody>
          {tours.map(t => (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t.destination}</td>
              <td>{t.departure_date}</td>
              <td>{t.departure_time}</td>
              <td>${t.price}</td>
              <td>{t.vehicle}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

